import store from '../store/store';

export default {
    async mounted() {
        await store.dispatch('requestIfIdle', ['getCMSData']);
    },
};
